import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import MobileStepper from "@material-ui/core/MobileStepper";
import Button from "@material-ui/core/Button";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

const useStyles = makeStyles(theme => ({
  stepper: {
    backgroundColor: "inherit"
  }
}));

function CardMediaStepper(props) {
  const classes = useStyles();
  const { toggleImage } = props;
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = 2;

  return (
    <>
      <MobileStepper
        className={classes.stepper}
        variant="dots"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={() => {
              setActiveStep(activeStep + 1);
              toggleImage();
            }}
            disabled={activeStep === maxSteps - 1}
          >
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button
            size="small"
            onClick={() => {
              setActiveStep(activeStep - 1);
              toggleImage();
            }}
            disabled={activeStep === 0}
          >
            <KeyboardArrowLeft />
          </Button>
        }
      />
    </>
  );
}

export default CardMediaStepper;
